import React from 'react';

const Inputs = ({
	inputType,
	required,
	label,
	type,
	placeholder,
	textArea,
	data,
	onChange,
}) => {
	return (
		<div
			className={
				'input-wrapper string' + (required ? ' required' : ' optional')
			}
		>
			<label
				className={'string' + (required ? ' required' : ' optional')}
				htmlFor={inputType}
			>
				{label ? label : ''}
			</label>
			{textArea ? (
				<textarea
					className={
						'string' + (required ? ' required' : ' optional')
					}
					placeholder={placeholder ? placeholder : ''}
					type={type ? type : 'text'}
					name={inputType}
					value={data[inputType]}
					onChange={onChange}
				/>
			) : (
				<input
					className={
						'string' + (required ? ' required' : ' optional')
					}
					placeholder={placeholder ? placeholder : ''}
					type={type ? type : 'text'}
					name={inputType}
					id={inputType}
					value={data[inputType]}
					onChange={onChange}
				/>
			)}
		</div>
	);
};

export default Inputs;
